var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state content--centered"},[_c('dashboard-image',{attrs:{"name":_vm.image}}),_vm._v(" "),_c('h1',{staticClass:"mt-5 text--centered",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"mt-3 text--grey text--centered",domProps:{"innerHTML":_vm._s(_vm.subtitle)}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }